import { IBookPhotographerModalProps } from '@bridebook/web/components/book-photographer/book-photographer-modal';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const BookPhotographerModal = lazyComponent<IBookPhotographerModalProps>(
  () => import('@bridebook/web/components/book-photographer/book-photographer-modal'),
);

const BookPhotographerModalLazy: React.FC = () => {
  const nextAction = useSelector((state) => state.ui.nextAction);

  if (
    nextAction &&
    nextAction.type === 'venueConfirmation' &&
    nextAction.action === 'discoverPhotographers' &&
    nextAction.active
  ) {
    return (
      <BookPhotographerModal
        supplier={nextAction.triggerAction.payload.item}
        show={nextAction.active}
      />
    );
  } else {
    return null;
  }
};

export default memo(BookPhotographerModalLazy);
